<template>
  <div class="columns is-mobile is-multiline">
    <div class="column is-full">
      <window title="Create a new poll">
        <poll-creator></poll-creator>
      </window>
    </div>
    <div class="column">
      <window title="View poll">
        <poll slug="test"></poll>
      </window>
    </div>
  </div>
</template>

<script>
import PollCreator from '@/components/poll/PollCreator.vue';
import poll from '@/components/poll/Poll.vue';

export default {
  components: { PollCreator, poll },
};
</script>
